<template>
  <v-container 
    v-if="!$apollo.loading"
    fill-height
    container--fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        v-if="!_.isEmpty(investorAccounts)"
        xs12
        pb-0
        d-inline-flex
        align-end
      >
        <h2 
          style="margin-bottom:0px;"
          :style="$vuetify.breakpoint.xs ? 'font-size:20px!important;' : ''"
        >
          {{ $t('accounts.myAccs') }}
        </h2>
        <v-spacer />
        <v-btn
          class="primary"
          @click="editAccount()"
        >
          {{ $t('accounts.addAccButton') }}
        </v-btn>
      </v-flex>  
      <v-flex
        v-if="!_.isEmpty(investorAccounts)"
        xs12
      >
        <v-card>
          <v-data-table
            class="accounts"
            :headers="headers"
            :items="investorAccounts"
            :hide-default-footer="true"
            :mobile-breakpoint="900"
            :items-per-page="200"
          >
            <template v-slot:header.qualified="{ }">
              <span>{{ $t('investors.qualified') }}</span>
              <template>
                <v-tooltip
                  top
                  max-width="300"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t('investors.qualifiedTooltip') }}
                </v-tooltip>
              </template>
            </template>
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                v-text="header.text"
              />
            </template> 

            <template v-slot:item.name="{ item }">
              <router-link :to="`account/${item.id}`">
                <b>{{ item.name }}</b>
              </router-link><br>
              <small>
                <span
                  v-if="item.dataroom.status == 'failed'"
                >
                  <template>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          style="font-size: 20px;margin-top:-3px;"
                          :class="colorStatus(item.dataroom.status)"
                          v-on="on"
                        >mdi-alert-circle</v-icon>
                      </template>
                      {{ $t('accounts.failedError') }}
                    </v-tooltip>
                  </template>
                </span>
                <b 
                  :class="colorStatus(item.dataroom.status)"
                >
                  {{ $t('globals.'+item.dataroom.status) }}
                </b>
              </small>
            </template> 
            <template v-slot:item.balance="{ item }">
              <b>
                {{ item.balance == null ? 0 : item.balance | formatMoney }} <small>{{ item.base_currency }}</small>
              </b>
            </template> 
            <template v-slot:item.dataroom="{ item }">
              <b>{{ item.dataroom.exchange.name }}</b><br>
              <small>{{ item.dataroom.account_id }}</small>
            </template> 
            <template v-slot:item.project="{ item }">
              <div
                v-if="item.project !== null"
                class="connected_project"
              >
                <router-link :to="`/ranking/${item.project.ranking_id}`">
                  <b>{{ item.project.ticker }}</b>
                </router-link>
                <span 
                  v-if="item.project !== null && item.project.connection_status == 'pending'"
                >
                  -  <b>{{ $t('globals.pending') }}</b>
                  <template>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information-outline</v-icon>
                      </template>
                      {{ $t('accounts.pendingTooltip1') }} 
                      <b>{{ item.project.request_sent | moment('L') }}</b>. 
                      {{ $t('accounts.pendingTooltip2') }}  
                    </v-tooltip>
                  </template>
                </span>
                <span 
                  v-if="item.project !== null && item.project.connection_status == 'declined'"
                >
                  -  <b>{{ $t('globals.declined') }}</b>
                  <template>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information-outline</v-icon>
                      </template>
                      {{ $t('accounts.declinedTooltip') }}
                    </v-tooltip>
                  </template>
                </span>
                <br><small>{{ item.project.name }}</small>
              </div>
              <div v-else>
                No
              </div> 
            </template> 
            <template v-slot:item.security_deposit="{ item }">    
              {{ item.base_currency | renderSymbol }}
              {{ item.project != null ? item.project.security_deposit : 0 | formatMoney }}
            </template>
            <template v-slot:item.qualified="{ item }">   
              <v-icon
                v-if="item.qualified"
                class="text-positive"
              >
                mdi-check
              </v-icon> 
              <v-icon
                v-else
                class="text-negative"
              >
                mdi-close
              </v-icon>
              {{ item.qualified ? $t('globals.yes') : $t('globals.no') }}
            </template>
           
            <template v-slot:item.actions="{ item }">
              <v-menu
                offset-y
                left
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    outlined 
                    small
                    text
                    v-on="on"
                  >
                    {{ $t('investors.detailsButton') }}
                  </v-btn>
                </template>
                <v-sheet dense>
                  <v-list-item
                    @click="editAccount(item)"
                  >
                    <v-list-item-title>{{ $t('accounts.editButton') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.project !== null && item.project.connection_status == 'connected'"
                    @click="disconnectProject(item)"
                  >
                    <v-list-item-title>{{ $t('globals.unlinkButton') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="confirmDeleteAccount(item)"
                  >
                    <v-list-item-title>{{ $t('globals.deleteButton') }}</v-list-item-title>
                  </v-list-item>
                </v-sheet>
              </v-menu>
            </template> 
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex
        v-else
        md5
        xs12
        new-record
      >
        <v-row>
          <v-col cols="12">
            <v-row
              justify="center"
              align="center"
            >
              <v-col>
                <v-card
                  style="padding:50px"
                >
                  <component :is="newIcon" />
                  <h3>{{ $t('accounts.noAccs1') }}</h3>
                  <p>
                    {{ $t('accounts.noAccs2') }}<b><a
                      href="https://www.bitmex.com/register"
                      target="_blank"
                    >Bitmex</a></b> 
                    {{ $t('accounts.or') }}
                    <b><a
                      href="https://accounts.binance.com/en/register"
                      target="_blank"
                    >Binance</a></b> 
                    {{ $t('accounts.noAccs3') }}
                  </p>
                  <v-btn
                    class="primary"
                    @click="editAccount()"
                  >
                    {{ $t('accounts.addAccButton') }}
                  </v-btn>
                </v-card> 
              </v-col>
            </v-row>  
          </v-col>
        </v-row>    
      </v-flex>
    </v-layout>
    <edit-account-dialog 
      :data="investorAccount"
      :show-dialog="editAccountDialog"
      @closeEditAccountDialog="closeEditAccountDialog"
    />
    <disconnect-dialog
      v-if="disconnectDialog"
      :show-dialog="disconnectDialog"
      :account-id="parseInt(investorAccount.id)"
      @closeDisconnectDialog="closeDisconnectDialog"
    />
    <increase-deposit-dialog
      v-if="increaseDepositDialog"
      :show-dialog="increaseDepositDialog"
    />
    <helper-confirm-dialog
      v-if="confirmDialog"
      :show-dialog="confirmDialog"
      :text="$t('accounts.reallyDelete', {name: selectedAccount.name})"
      @closeConfirmDialog="closeConfirmDialog"
    />
  </v-container>
</template>

<script>

import INVESTOR_ACCOUNTS_QUERY  from '@/graphql/queries/InvestorAccounts.gql';
import DELETE_ACCOUNT_MUTATION  from '@/graphql/mutations/DeleteInvestorAccount.gql'

import EditAccountDialog from '@/views/Accounts/partial/EditAccountDialog.vue'
import DisconnectDialog from '@/views/Accounts/partial/DisconnectDialog.vue'
import IncreaseDepositDialog from '@/views/Accounts/partial/IncreaseDepositDialog.vue'
import IconWallet from '@/components/icons/IconWallet.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'InvestorAccountsList',
  components: {
    EditAccountDialog,
    DisconnectDialog,
    IncreaseDepositDialog
  },
  data() {
    return {
      newIcon: IconWallet,
      confirmDialog: false,
      selectedAccount: null,
      investorAccounts: [],
      investorAccount: {},
      loading: false,
      editAccountDialog: false,
      disconnectDialog: false,
      increaseDepositDialog: false,
      headers: [
        {
          sortable: false,
          text: this.$t('accounts.name'),
          value: 'name'
        },
        {
          sortable: false,
          text: this.$t('globals.balance'),
          value: 'balance'
        },
        {
          sortable: false,
          text: this.$t('accounts.joined'),
          value: 'project'
        },
        {
          sortable: false,
          text: this.$t('accounts.exchange'),
          value: 'dataroom'
        },
        {
          sortable: false,
          text: this.$t('investors.qualified'),
          value: 'qualified'
        },
        {
          sortable: false,
          text: '',
          value: 'actions'
        },
        
      ]
    } 
  },
  computed: {
     ...mapGetters('user', ['getUser']),
  },
  methods: {
    confirmDeleteAccount(account) {
      this.confirmDialog = true
      this.selectedAccount = account
    },
    closeConfirmDialog(confirmed) {
      this.confirmDialog = false
      if (confirmed) {
        this.deleteAccount()
      }
    },
    deleteAccount() {
      this.$apollo
      .mutate({
        mutation: DELETE_ACCOUNT_MUTATION,
        variables: {
          id: this.selectedAccount.id,
        }
      })
      .then(data => {
        this.$store.commit('app/setNotifier', this.$t('globals.success'));
        this.$apollo.queries.investorAccounts.refetch()
      })
      .catch(error => {
        this.errorHandler(error);
        this.loading = false;
      });
    },
    editAccount(account) {
      this.selectedAccount = account
      this.investorAccount = {}
      if (account !== undefined) 
        this.investorAccount = _.cloneDeep(account)
      this.editAccountDialog = true
    },
    disconnectProject(account) {
      this.investorAccount = account
      this.disconnectDialog = true
    },
    closeDisconnectDialog(val) {
      this.disconnectDialog = false
      if (val == 'disconnect') {
        this.$apollo.queries.investorAccounts.refetch()
      }
    },
    closeEditAccountDialog(val) {
      this.editAccountDialog = false
      if (val) {
        this.$apollo.queries.investorAccounts.refetch()
      }
    }
  },
  apollo: {
    investorAccounts: {
      query: INVESTOR_ACCOUNTS_QUERY,
    }
  }
}
</script>
<style lang="scss" >

.connected_project {
  b {
    font-weight: 700;
  }
  i {
    font-size: 17px!important;
    margin-left:5px!important;
  }
}
.accounts {
  th {
    .v-icon {
      margin-left: 4px;
      font-size: 16px;
    }
  }
  &.v-data-table {
    .text-start {
      padding:10px;
    }
  }
}

  
</style>
